import { AlertCircle } from 'lucide-react';
import { Card } from '../ui/Card';

export function PricingInfoCard() {
  return (
    <Card className="p-4 bg-amber-50 border-amber-200">
      <div className="flex items-start gap-3">
        <AlertCircle className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" />
        <div className="flex-1">
          <h3 className="font-semibold text-amber-900 mb-2">
            Prix indicatifs moyens
          </h3>
          <p className="text-sm text-amber-800 mb-3">
            Ces montants sont des prix moyens constatés en France métropolitaine en 2025.
            Ils incluent la fourniture et la pose, mais peuvent varier selon:
          </p>
          <ul className="text-sm text-amber-800 space-y-1 ml-4 list-disc">
            <li>Votre région et l'accessibilité du chantier</li>
            <li>Le prestataire choisi et son niveau de qualification RGE</li>
            <li>Les spécificités techniques de votre logement</li>
          </ul>
          <p className="text-sm font-semibold text-amber-900 mt-3">
            ⚠️ Ces estimations n'incluent PAS les aides financières (MaPrimeRénov, CEE, éco-PTZ)
          </p>
        </div>
      </div>
    </Card>
  );
}
